import LyDashboard from './src/index.vue'

LyDashboard.install = function (Vue) {
    Vue.component(LyDashboard.name, LyDashboard)
}

export default LyDashboard



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/ly-dashboard/index.js
// module id = null
// module chunks = 